import request from '@/utils/request'

// 查询所有门店名字
export function getAllStoreName(params) {
  return request({
    url: '/api/manage/v1/store/nameAndIdList',
    method: 'get',
    params
  })
}

// 获取门店优惠券列表
export function getStoreCouponsList(params) {
  return request({
    url: '/api/manage/v1/CouponStore/page',
    method: 'get',
    params
  })
}

// 添加门店优惠券
export function addStoreCoupons(data) {
  return request({
    url: '/api/manage/v1/CouponStore/create',
    method: 'post',
    data
  })
}

// 查看门店优惠券
export function getStoreCoupons(params) {
  return request({
    url: '/api/manage/v1/CouponStore/' + params,
    method: 'get',
  })
}

// 修改门店优惠券
export function updateStoreCoupons(data) {
  return request({
    url: '/api/manage/v1/CouponStore/modify',
    method: 'post',
    data
  })
}

// 开启禁用门店优惠券
export function openOrCloseStoreCoupons(data) {
  return request({
    url: '/api/manage/v1/CouponStore/enable',
    method: 'post',
    data
  })
}

// 删除门店优惠券
export function deleteStoreCoupons(data) {
  return request({
    url: '/api/manage/v1/CouponStore/deleted',
    method: 'post',
    data
  })
}

// 全部优惠券信息(启用状态)
export function getAllCoupons(params) {
  return request({
    url: '/api/manage/v1/coupon/nameAndIdList',
    method: 'get',
    params
  })
}
//第三方sku列表
// export function thirdPartySkuList(params) {
//   return request({
//     url: '/api/manage/v1/activity/thirdParty/skuList',
//     method: 'get',
//     params
//   })
  //第三方sku列表
export function thirdPartySkuList(params) {
  return request({
    url: '/openapi/common/douyin/skus',
    method: 'get',
    params
  })
}